const config = {
  "jwksAppName": {
    "production": "callerIdAudit",
    "sandBox": "callerIdAuditSandbox"
  },
  "apiBaseUrl": "https://6h4z5frnzf.execute-api.us-east-2.amazonaws.com/cicd-prod/",
  "rcApiBaseUrl": "https://api.ringcentral.com/restapi/v1.0",
  "rcApiInternalUrl": "https://platform-dpwdevxmn.lab.nordigy.ru/restapi/v1.0",
  "rc_client_Id": "QslrTRuXT4Wphx5i98bYFA",
  "rc_authorize_uri": "https://api.ringcentral.com/restapi/oauth/authorize?response_type=code",
  "rc_jwks_url": "https://auth.ps.ringcentral.com/jwks"
};

export default config;
